import Swiper from "swiper";
import { addToGlobalThisRet, lockBody, unlockBody, initSimpleTooltips, initToggleActiveClass } from "@plugins";

const fancyboxWrappers = document.querySelectorAll("[data-custom-fancybox-wrapper]");

window.addEventListener("load", initFancybox());

function initFancyboxSlider(fancybox, currentIndex) {
    if(fancybox) {
        const fancyboxSlider = fancybox.querySelector(".js-custom-fancybox-slider");
        const thumbs = fancybox.querySelector(".js-custom-fancybox-thumbs");
        const buttonPrev = fancyboxSlider.querySelector(".js-slider-button-prev");
        const buttonNext = fancyboxSlider.querySelector(".js-slider-button-next");

        const fancyboxSliderThumbs = new Swiper(thumbs, {
            spaceBetween: 8,
            slidesPerView: "auto",
        });

        const swiper = new Swiper(fancyboxSlider, {
            spaceBetween: 16,
            thumbs: {
                swiper: fancyboxSliderThumbs,
                slideThumbActiveClass: "active",
            },
            navigation: {
                prevEl: buttonPrev,
                nextEl: buttonNext,
            },
            breakpoints: {
                992: {
                    spaceBetween: 0,
                }
            }
        });

        swiper.setProgress(currentIndex);
        fancyboxSliderThumbs.setProgress(currentIndex);
    }
}

function initFancybox() {
    if (fancyboxWrappers) {
        fancyboxWrappers.forEach(wrapper => {
            const fancyboxItems = wrapper.querySelectorAll("[data-custom-fancybox-item]");
            fancyboxItems.forEach((item, index) => {
                item.addEventListener("click", (e) => {
                    e.preventDefault();
        
                    const target = e.target;
                    const currentWrap = target.closest("[data-custom-fancybox-wrapper]");
                    const currentIndex = 1 * index / (fancyboxItems.length - 1);
                    copyModalItems(currentWrap, currentIndex);
                });
            });
        });
    }
}

function copyModalItems(currentWrap, currentIndex) {
    const currentWrapItems = currentWrap.querySelectorAll("[data-custom-fancybox-item]");
    const arrayItems = [];

    currentWrapItems.forEach(item => {
        arrayItems.push(item);
    })

    createModal(arrayItems, currentWrap, currentIndex);
}

function createModal(arrayItems, currentWrap, currentIndex) {
    const body = document.querySelector("body");
    
    body.insertAdjacentHTML("beforeend", 
    `        
        <div class="custom-fancybox js-custom-fancybox">
            <div class="custom-fancybox__inner">
                <div class="custom-fancybox__header">
                    <div class="container">
                        <div class="custom-fancybox__header-wrap js-custom-fancybox-header-wrap">
                            <a href='index.html' class='logo custom-fancybox__header-logo'>
                                <img class="logo__image" src="images/logo.svg" alt="moiki-new">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="swiper custom-fancybox__slider js-custom-fancybox-slider">
                    <div class="swiper-wrapper custom-fancybox__pic-list js-custom-fancybox-pic-list">
                    </div>
                    <div class="custom-fancybox__close popup__close js-custom-fancybox-close"></div>
                    <button type="button" class="slider-button slider-button--white-bg slider-button-prev js-slider-button-prev"></button>
                    <button type="button" class="slider-button slider-button--white-bg slider-button-next js-slider-button-next"></button>
                </div>
                <div class="custom-fancybox__thumbs">
                    <div class="container">
                        <div class="swiper js-custom-fancybox-thumbs">
                            <div class="swiper-wrapper custom-fancybox__thumbs-list js-custom-fancybox-thumbs-list">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
    )

    const fancybox = document.querySelector(".js-custom-fancybox");

    createModalHeader(fancybox, currentWrap);
    createModalSlides(arrayItems, fancybox);
    initFancyboxSlider(fancybox, currentIndex);
    setTimeout(() => {
        fancybox.classList.add("shown");
    }, 0);
    closeModalGallery(fancybox);
    lockBody(fancybox, {
        reserveScrollBarGap: true,
    });
}

function createModalHeader(fancybox, currentWrap) {
    if (currentWrap.dataset.customFancyboxWrapper === "gallery") {
        const headerInfo = document.querySelector(".js-custom-fancybox-header-product-info");
        const headerWrap = fancybox.querySelector(".js-custom-fancybox-header-wrap");

        const headerInfoCopy = headerInfo.cloneNode(true);
        headerWrap.appendChild(headerInfoCopy);
        initSimpleTooltips(".js-custom-fancybox-action");
        initToggleActiveClass(".js-card-actions", ".js-custom-fancybox-action");
    }
}

function createModalSlides (arrayItems, fancybox) {
    const fancyboxSlidesList = fancybox.querySelector(".js-custom-fancybox-pic-list");
    const fancyboxThumbsList = fancybox.querySelector(".js-custom-fancybox-thumbs-list");
    const fragmentSlides = document.createDocumentFragment();
    const fragmentThumbs = document.createDocumentFragment();

    arrayItems.forEach(item => {
        const slide = document.createElement("div");
        const slideBg = document.createElement("img");
        const thumb = document.createElement("div");
        const thumbBg = document.createElement("img");

        slide.classList.add("swiper-slide", "custom-fancybox__pic-item");
        slideBg.src = item.dataset.src;
        thumbBg.src = item.dataset.src;
        thumb.appendChild(thumbBg);
        
        if (item.dataset.customFancyboxItem === "video") {
            const slideLink = document.createElement("a");

            slideLink.href = item.dataset.href;
            slideLink.dataset.fancybox = "";
            slideLink.classList.add("video");
            slideLink.appendChild(slideBg);
            slide.appendChild(slideLink);

            thumb.classList.add("swiper-slide", "custom-fancybox__thumb", "custom-fancybox__thumb--video");
        } else {
            slide.appendChild(slideBg);
            thumb.classList.add("swiper-slide", "custom-fancybox__thumb");
        }

        fragmentSlides.appendChild(slide);
        fragmentThumbs.appendChild(thumb);
    })

    fancyboxSlidesList.appendChild(fragmentSlides);
    fancyboxThumbsList.appendChild(fragmentThumbs);
}

function closeModalGallery(fancybox) {
    const fancyClose = fancybox.querySelector(".js-custom-fancybox-close");

    fancyClose.addEventListener("click", () => {
        fancybox.classList.remove("shown");
        setTimeout(() => {
            fancybox.remove();
        }, 300);
        unlockBody();
    })
}

// Записываем в глобальный подобъект для бэка
addToGlobalThisRet(initFancybox, "initFancybox");
